/**
 * noop method. It takes no arguments and does not return anything. Useful
 * when you need to setup an initial placeholder function.
 */
function noop() {
}

module.exports = noop;
